var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.limitsRequired
        ? _c(
            "fl44-contract-supplementary-agreement-termination-limits-editable-table",
            {
              attrs: {
                "total-cost": _vm.supplementaryAgreement.price,
                "limit-year": _vm.purchase.purchase_limit_year,
                "order-type": _vm.purchase.order_type,
                "purchase-type": "fl44",
                "purchase-id": _vm.purchase.id,
              },
              on: { validate: _vm.limitsValidate },
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c(
                          "h5",
                          {
                            staticClass:
                              "grey-color ml-1 mt-3 mb-1 main_text font-weight-bold",
                          },
                          [_vm._v("Измените лимиты")]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "label-hint",
                    fn: function () {
                      return [
                        _vm._v(
                          " Добавьте или измените лимиты. Необходимо полностью распределить стоимость дополнительного соглашения по соответствующим лимитам. "
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "label-total",
                    fn: function () {
                      return [
                        _vm._v(" Стоимость дополнительного соглашения, руб.: "),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "label-variance",
                    fn: function () {
                      return [
                        _vm._v(
                          " Отклонение от стоимости дополнительного соглашения, руб.: "
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                3974617782
              ),
              model: {
                value: _vm.form.limits.items,
                callback: function ($$v) {
                  _vm.$set(_vm.form.limits, "items", $$v)
                },
                expression: "form.limits.items",
              },
            }
          )
        : _vm._e(),
      _vm.limitsRequired
        ? _c("form-row-edit-supplier-accounting", {
            on: { validate: _vm.supplierAccountingValidate },
            scopedSlots: _vm._u(
              [
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c(
                        "h5",
                        {
                          staticClass:
                            "ml-1 mt-3 mb-1 main_text font-weight-bold",
                        },
                        [_vm._v("Банковские реквизиты поставщика")]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "info",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "ml-1 fs-14" }, [
                        _vm._v(
                          "Укажите банковские реквизиты поставщика для заключения контракта, которые будут переданы в РИС после заключения."
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2408927631
            ),
            model: {
              value: _vm.form.supplier_accounting,
              callback: function ($$v) {
                _vm.$set(_vm.form, "supplier_accounting", $$v)
              },
              expression: "form.supplier_accounting",
            },
          })
        : _vm._e(),
      _c("fl44-contract-customer-sign-supplementary-agreement-button", {
        staticClass: "mb-2",
        attrs: {
          purchase: _vm.purchase,
          "is-available": !_vm.$v.$invalid,
          form: _vm.form,
          "supplementary-agreement": _vm.supplementaryAgreement,
        },
        on: {
          refresh: function ($event) {
            return _vm.$emit("refresh")
          },
        },
      }),
      _vm.supplementaryAgreement.type.id === "termination"
        ? _c(
            "p",
            { staticClass: "font-weight-bold text-danger mt-2 mb-1 fs-14" },
            [
              _vm._v(
                "Внимание! Для данной закупки будут заблокированы функции: изменение лимитов, добавление дополнительного соглашения, изменение статуса."
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }